import { css } from '@emotion/react'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel, Text } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { isNumberInRange } from 'util/number/number-in-range'
import {
  IDADE_FORA_DE_RASTREIO_TEXT,
  SaudeMulherResultadoExameModel,
} from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { EXAMES_CANCER_MAMA_TOOLTIP_TEXT, RANGE_IDADE_RASTREIO_CANCER_MAMA } from './constants-saudeMulher'

interface RastreamentoCancerDeMamaPanelProps {
  ultimaSolicitacao: SaudeMulherResultadoExameModel
  ultimaAvaliacao: SaudeMulherResultadoExameModel
  ultimaRealizacao: SaudeMulherResultadoExameModel
  idadeCidadao: number
  iconColor: Color
}

export function RastreamentoCancerDeMamaPanel(props: Readonly<RastreamentoCancerDeMamaPanelProps>) {
  const { ultimaSolicitacao, ultimaAvaliacao, ultimaRealizacao, idadeCidadao, iconColor } = props

  const isInRange = isNumberInRange(idadeCidadao, RANGE_IDADE_RASTREIO_CANCER_MAMA)

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} color={iconColor} />
          <Heading level={4}>Rastreio para câncer de mama</Heading>
          <InfoIcon icon='infoCircleFilled' text={EXAMES_CANCER_MAMA_TOOLTIP_TEXT} tooltipStyle={styles.tooltipStyle} />
        </HFlow>
      </Cell>
      {isInRange ? (
        <Fragment>
          <Cell size={3}>
            <InfoLabel title='Última solicitação'>
              {formatDate(ultimaSolicitacao?.exameRequisitado?.dataSolicitacao)}
            </InfoLabel>
          </Cell>
          <Cell size={3}>
            <InfoLabel title='Última realização'>
              {formatDate(ultimaRealizacao?.exameRequisitado?.dataRealizacao)}
            </InfoLabel>
          </Cell>
          <Cell size={3}>
            <InfoLabel title='Última avaliação'>{formatDate(ultimaAvaliacao?.dataAvaliacao)}</InfoLabel>
          </Cell>
          <Cell size={3} />
        </Fragment>
      ) : (
        <Cell size={12}>
          <Text fontStyle='italic'>{IDADE_FORA_DE_RASTREIO_TEXT}</Text>
        </Cell>
      )}
    </Grid>
  )
}

const styles = {
  tooltipStyle: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
